import React from 'react';
import CONFIG from "../../../config";

const { LINKS } = CONFIG;

interface IOffices {
    parentClass: string;
}

const Offices: React.FC<IOffices> = ({ parentClass }) => (
    <a className={parentClass} href={LINKS.BAIBOL.OFFICES} target="_blank" rel="noopener noreferrer nofollow">
        <span className={`${parentClass}__icon`}></span>
        <span className={`${parentClass}__text`}>Отделения</span>
    </a>
);

export default Offices;
